import React, { useState } from 'react'
import './style.css'

export default function RenderProfilePicture({ image, cached, circle, width, height, className = '' }) {
  const [cachedImage, setCachedImage] = useState(image)

  return (
    <div
      className={`bio__avatar ${circle && 'circle'} ${className}`}
      style={{ background: `url(${cached ? cachedImage : image})`, width: width, height: height }}
    >
      {null}
    </div>
  )
}
